import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'relativeDateFormat',
  standalone: true,
})
export class RelativeDateFormatPipe implements PipeTransform {
  transform(value: string | null): string | null{
    if (!value) return value;

    const fechaSplit = value.split('/');
    const dia = parseInt(fechaSplit[0], 10);
    const mes = parseInt(fechaSplit[1], 10) - 1;
    const anio = parseInt(fechaSplit[2], 10);

    const fechaProporcionadaObj:any = new Date(anio, mes, dia);
    const fechaActual: any = new Date();

    const diferenciaEnMilisegundos: number =
      fechaActual - fechaProporcionadaObj;
    const diferenciaEnDias = Math.floor(
      diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)
    );
    const diferenciaEnMeses =
      fechaActual.getMonth() -
      fechaProporcionadaObj.getMonth() +
      12 * (fechaActual.getFullYear() - fechaProporcionadaObj.getFullYear());

    if (diferenciaEnMeses >= 1) {
      return `Hace ${diferenciaEnMeses} mes${
        diferenciaEnMeses > 1 ? 'es' : ''
      }`;
    } else if (diferenciaEnDias >= 1) {
      return `Hace ${diferenciaEnDias} día${diferenciaEnDias > 1 ? 's' : ''}`;
    } else {
      return 'Hoy';
    }
  }
}
